<template>
  <div class="columns-order">
    <div class="columns-order__counter">
      {{ _getTr("selected_columns").format(columnsCount) }}
    </div>
    <div class="columns-order__order">
      <Vuedraggable
        ref="draggableContainer"
        :value="groupedItems"
        :force-fallback="true"
        ghost-class="column-order_drag-item_dragging"
        drag-class="column-order_drag-handle"
        handle=".column-order_draggable-handle"
        :animation="150"
        @input="handleItemsReorder"
      >
        <ColumnsOrderItem
          v-for="item in groupedItems"
          :key="item[0]"
          :items="item"
          :columns-map="columnsMap"
          class="column-order_draggable-handle"
          @removeItem="handleItemRemove"
        />
      </Vuedraggable>
    </div>
  </div>
</template>

<script>
  import Vuedraggable from 'vuedraggable';
  import ColumnsOrderItem from 'components/Data/TableSettings/TableSettingsModal/ColumnsOrder/ColumnsOrderItem';
  import _ from 'lodash';

  _.noConflict();

  export default {
    name: 'ColumnsOrder',
    components: {ColumnsOrderItem, Vuedraggable},
    props: {
      selectedItems: {
        type: Array,
        required: true
      },
      columnsMap: {
        type: Object,
        required: true
      }
    },
    computed: {
      columnsCount () {
        return this.selectedItems.length;
      },
      groupedItems () {
        return Object.values(_.groupBy(
          this.selectedItems,
          (item) => {
            const i = this.columnsMap[item];
            return i.groupInfo.union ? i.groupInfo.id : i.id;
          }));
      }
    },
    methods: {
      handleItemsReorder (val) {
        this.$emit('reorder', val.flat());
      },
      handleItemRemove (itemId) {
        this.$emit('toggleItems', {status: false, itemIds: [itemId]});
      }
    }
  };
</script>

<style>
  .columns-order {
    padding: 16px;
  }

  .columns-order__counter {
    font-size: 16px;
    font-weight: var(--medium-font-weight);

    color: var(--panel-text-color);
    line-height: 18px;
  }
</style>
